// extracted by mini-css-extract-plugin
export default {"title":"game_title__KnJmI"};